<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{caption}}
        </template>
        <template slot="input">
            <div class="input-container">
                <switch-button inline @selected="selectNegation" v-model="negation" :options="negationOptions"/>
                <inline-switch @selected="selectMode"
                               v-model="conditionMode"
                               :options="conditionModeOptions"/>
                <template v-if="conditionMode == 'empty'">
                    <div class="inline-text">
                        N/A
                    </div>
                </template>
                <template v-else-if="conditionMode == 'query'">
                    <div class="inline-text">
                        <simple-button @press="() => showSubquery = !showSubquery"><icon :icon="['fal', showSubquery ? 'search-minus' : 'search-plus']"/></simple-button>
                        &nbsp;
                        {{Object.keys(internalQuery.parameters).length}} value{{Object.keys(internalQuery.parameters).length == 1 ? "" : "s"}}
                    </div>
                    <div style="position: absolute; width: 800px; border: 1px solid #C85858; background-color: rgba(57,66,75,1); z-index: 900; left: 115px; top: 20px; display: flex; flex-flow: column"
                         v-show="showSubquery">
                        <div style="height: 20px;"></div>
                        <div style="padding: 10px;">
                            <filter-form v-model="internalQuery" :filter-definition="searchQueryDefinitions[this.object]"/>
                        </div>
                    </div>
                </template>
                <template v-else-if="conditionMode == 'in'">
                    <input :value="selectedValuesString" :class="{ 'input-component': true, 'active': active}"
                           @input="handleInput" @click="showSelection" ref="inputComponent"/>
                    <div class="selection-container" ref="selectionContainer" v-show="selectionOpen">
                        <div class="selection-buttons">
                            <simple-button @press="clearSelected">Clear</simple-button>
                            <simple-button @press="hideSelection">OK</simple-button>
                            <input v-model="namesFilter" :class="{ 'input-component': true, 'active': active}"/>
                        </div>
                        <div :class="{ 'selection-option': true, 'selected': selectedOptions.find(opt => opt.id == option.id) } "
                             v-for="option in filteredOptions" @click="selectOption(option)">
                            <div class="selection-option-check">
                                <icon :icon="['fal', 'check']" v-if="selectedOptions.find(opt => opt.id == option.id)"/>
                            </div>
                            <div class="selection-option-name">
                                {{option.name}}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
    </form-input-layout>
</template>

<script>
    import FormInputLayout from "../form/FormInputLayout";
    import SwitchButton from "../button/SwitchButton";
    import SimpleButton from "../button/SimpleButton";
    import InlineSwitch from "../button/InlineSwitch";
    import FilterForm from "./FilterForm";
    import QueryUtils from "../../utils/QueryUtils";

    export default {
        name: "FilterEntityInputSelection",
        components: {FilterForm: () => import('./FilterForm.vue'), InlineSwitch, SimpleButton, SwitchButton, FormInputLayout},
        props: {
            helpItemCode: String,
            disabled: Boolean,
            caption: String,
            options: Array,
            value: Object,
            type: String,
            object: String
        },
        data: function () {
            return {
                showSubquery: false,
                selectionOpen: false,
                namesFilter: "",
                conditionMode: "",
                stringValue: "",
                active: false,
                selectedOptions: [],
                negation: "",
                internalQuery: {parameters: {}, object: this.object}
            }
        },
        computed: {
            negationOptions() {
                return [{caption: this.$t("searchQuery.not"), value: "not"}];
            },
            filteredOptions() {
                return (this.options ?? []).filter(opt => opt.name.toLowerCase().includes(this.namesFilter.toLowerCase()));

            },
            selectedValuesString() {
                return this.selectedOptions.sort((optA, optB) => optA.name.localeCompare(optB.name)).map(opt => opt.name).join(", ");
            },
            selectedValuesIds() {
                return this.selectedOptions.sort((optA, optB) => optA.id.localeCompare(optB.id)).map(opt => opt.id).join(";");
            },
            conditionModeOptions() {
                return [
                    {caption: this.$t('searchQuery.in'), value: "in"},
                    {caption: this.$t('searchQuery.inQuery'), value: "query"},
                    {
                        caption: this.$t('searchQuery.isEmpty'),
                        value: 'empty'
                    }
                ]
            },
            searchQueryDefinitions() {
                return {
                    account: QueryUtils.getByType("account", {currencies: [], accounts: []}),
                    CreditRisk: QueryUtils.getByType("creditRisk", {currencies: [], accounts: []}),
                    cashEvent: QueryUtils.getByType("cashEvent", {currencies: [], accounts: []}),
                    reconciliationMatch: QueryUtils.getByType("reconciliationMatch", {currencies: [], accounts: []}),
                    accountBalance: QueryUtils.getByType("accountBalance", {currencies: [], accounts: []}),
                    accountBalanceItem: QueryUtils.getByType("accountBalanceItem", {currencies: [], accounts: []})
                }
            }
        },
        methods: {
            selectNegation(negValue) {
                this.negation = negValue;
                this.$emit('input', this.transformResult());
            },
            selectMode(mode) {
                if(mode != 'query') {
                    this.internalQuery = { parameters: { }, object: this.object}
                    this.showSubquery = false;
                }
                this.conditionMode = mode;
                this.$emit('input', this.transformResult());
            },
            handleInput() {
                this.$emit('input', this.transformResult());
            },
            selectOption(option) {
                let alreadySelected = this.selectedOptions.find(opt => opt.id == option.id);
                if (alreadySelected != undefined) {
                    this.selectedOptions.splice(this.selectedOptions.indexOf(alreadySelected), 1);
                } else {
                    this.selectedOptions.push(option)
                }
                this.$emit('input', this.transformResult());
            },
            clearSelected() {
                this.selectedOptions.splice(0, this.selectedOptions.length);
            },
            showSelection() {
                this.selectionOpen = true;
                let container = this.$refs.selectionContainer;
                let inputComponent = this.$refs.inputComponent;
                let closeListener = function (e) {
                    if (!container.contains(e.target)) {
                        this.hideSelection();
                        document.removeEventListener('mouseup', closeListener);
                    }

                }.bind(this);
                document.addEventListener('mouseup', closeListener);
                container.style.width = inputComponent.offsetWidth + "px";
                container.style.left = inputComponent.offsetLeft + "px";
                container.style.top = (inputComponent.offsetTop + inputComponent.offsetHeight) + "px";
            },
            hideSelection() {
                this.selectionOpen = false;
            },
            transformResult() {
                if (this.selectedValuesIds != "" && this.selectedValuesIds != null && this.conditionMode == 'in') {
                    return {
                        type: this.type ?? 'entity',
                        operator: this.conditionMode,
                        value: this.selectedValuesIds,
                        negation: this.negation === "not"
                    };
                } else if (this.conditionMode == 'query') {
                    let result = {
                        type: this.type ?? 'entity',
                        operator: "in",
                        value: '',
                        negation: this.negation === "not",
                        searchQuery: this.internalQuery
                    }

                    return result;
                } else if (this.conditionMode == 'empty') {
                    return {
                        type: this.type ?? 'entity',
                        operator: this.conditionMode,
                        value: '',
                        negation: this.negation === "not"
                    };
                } else {
                    return undefined;
                }

            }
        },
        watch: {
            internalQuery: {
                handler(newVal, oldVal) {
                    this.$emit('input', this.transformResult());
                }
            },
            value: {
                handler(newVal, oldVal) {
                    //console.log("newVal select", newVal)
                    if (newVal != undefined && newVal.value != undefined) {
                        this.$set(this, 'selectedOptions', newVal.value?.split(";").map(val => ({
                            id: val,
                            name: this.options.find(opt => opt.id == val).name
                        })) ?? null);
                        this.$set(this, 'conditionMode', newVal.operator);
                        this.$set(this, 'negation', newVal.negation || newVal.negation == 'not' ? "not" : "");
                    } else {
                        this.selectedOptions = [];
                        this.conditionMode = "";
                        this.negation = "";
                    }

                },
                immediate: true
            }
        }
    }
</script>

<style scoped lang="scss">
    .input-container {
        display: flex;
        flex-flow: row;
        white-space: nowrap;
        border-bottom: 1px solid var(--input-border-color);
        background-color: var(--input-background-color);
    }

    .input-component {
        background-color: transparent;
        border: none;
        color: var(--input-font-color);
        padding: 5px 10px 5px 10px;
        outline: none;
        width: 100%;
        font-family: Source Sans Pro;
    }

    .active {
        color: var(--input-active-font-color);
        background-color: var(--input-active-background-color);
        border: 1px solid var(--input-active-border-color);
    }

    .required {
        color: var(--accent-color);
    }

    .selection-container {
        position: absolute;
        background-color: var(--input-background-color);
        top: 27px;
        left: 23px;
        width: 50px;
        min-height: 80px;
        z-index: 9999;
        overflow-x: hidden;
        border-left: 1px solid var(--input-border-color);
        border-right: 1px solid var(--input-border-color);
        border-bottom: 1px solid var(--input-border-color);
    }

    .selection-option {
        padding: 2px;
        color: var(--input-font-color);
        display: flex;
        flex-flow: row;
    }

    .selection-option:hover {
        background-color: var(--accent-color);
        color: var(--input-active-font-color);
        cursor: pointer;

    }

    .selected > .selection-option-check {
        background-color: var(--accent-color);
        color: var(--input-active-font-color)
    }

    .selection-option-check {
        width: 15px;
        padding: 0px 2px 0px 2px;
    }

    .selection-option-name {
        padding: 0px 0px 0px 2px;
    }

    .selection-buttons {
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-items: end;
        background-color: var(--input-border-color);
    }

    .selection-buttons > * {
        margin: 2px;
    }

    .inline-text {
        display: flex;
        padding: 0px 5px 0px 5px;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
</style>